export default __webpack_public_path__ + "static/media/assassin.71ec6116.png";